import axios from '../axiosConfig';

const base = '/api/system-announcements';
const readerPath = scope => `${base}/${scope.type === 'global' ? 'global/' : ''}entities/${scope.carrier}`;
const managerPath = scope => `${base}/manage${scope.type === 'entity' ? `/entities/${scope.entityId}` : ''}`;
const options = signal => ({ signal, timeout: 10000 });
const unwrap = response => {
  if (response.data?.success !== true || !response.data.data) throw new Error('Invalid announcement response');
  return response.data.data;
};
const service = {
  feed: (scope, cursor, signal) => axios.get(readerPath(scope), {
    ...options(signal), params: cursor ? { cursor } : {}
  }).then(unwrap),
  detail: (scope, id, signal) => axios.get(`${readerPath(scope)}/${id}`, options(signal)).then(unwrap),
  acknowledge: (scope, id, dismiss, signal) => axios.put(`${readerPath(scope)}/${id}/${dismiss ? 'dismiss' : 'read'}`, {}, options(signal)).then(unwrap),
  manage: (scope, cursor, signal) => axios.get(managerPath(scope), { ...options(signal), params: cursor ? { cursor } : {} }).then(unwrap),
  create: (scope, draft, signal) => axios.post(managerPath(scope), draft, options(signal)).then(unwrap),
  edit: (scope, id, draft, signal) => axios.put(`${managerPath(scope)}/${id}`, draft, options(signal)).then(unwrap),
  transition: (scope, id, action, revision, signal) => axios.post(`${managerPath(scope)}/${id}/${action}`, { revision }, options(signal)).then(unwrap),
};
export default service;
